import React from 'react';
import type { ErrorBoundaryType } from '../components/ErrorBoundary';

interface ContactUsLinkProps {
  children: React.ReactNode;
}

const ContactUsLink = ({ children }: ContactUsLinkProps) => (
  <a href="mailto:support@slab.com">{children}</a>
);

interface RootErrorBoundaryFallbackProps {
  type: ErrorBoundaryType;
}

const RootErrorBoundaryFallback = ({
  type,
}: RootErrorBoundaryFallbackProps) => {
  const tryAgainLink = (
    <a
      href="/"
      onClick={(e) => {
        e.preventDefault();
        window.location.reload();
      }}
    >
      try again
    </a>
  );

  return (
    <div style={{ margin: 12 }}>
      <h2>Oops! Something went wrong.</h2>
      {type === 'translation' && (
        <>
          <p>
            The error is most likely caused by a translation tool. Please
            disable it and {tryAgainLink}.
          </p>
          <p>
            If the problem persists, feel free to{' '}
            <ContactUsLink>contact us</ContactUsLink>.
          </p>
        </>
      )}
      {type === 'unsupportedBrowser' && (
        <>
          <p>
            Your browser may be outdated or not supported by Slab. Please update
            your browser or try a different one.
          </p>
          <p>
            Still need help or think it’s a mistake?{' '}
            <ContactUsLink>Contact us</ContactUsLink>.
          </p>
        </>
      )}
      {type === 'unknown' && (
        <>
          <p>The error has been logged and we’ll be on it!</p>
          <p>
            Please {tryAgainLink} later or{' '}
            <ContactUsLink>contact us</ContactUsLink> if the problem persists.
          </p>
        </>
      )}
    </div>
  );
};

export default RootErrorBoundaryFallback;
